module.exports = __webpack_public_path__ + "img/zazie.f4a958c9.jpg";